import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import { MouseEvent } from "react";
import Proposal from "work/proposals/proposal";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import FeeScheduleTemplatesTable from "work/fee-schedule-templates/_views/tables/fee-schedule-templates-table";
import { Masked } from "work/_shared/masked-fields";
import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";

const FeeLink = styled(Link, { shouldForwardProp: (prop) => prop !== "revised" })<{ revised?: boolean }>(
  ({ theme, revised }) => ({
    alignItems: "center",
    color: theme.palette.text.primary,
    cursor: "pointer",
    display: "flex",
    overflow: "hidden",
    textDecoration: revised ? "underline dotted red" : "underline",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  })
);

type FeeScheduleLinkProps = {
  proposal: Proposal;
};

export default function FeeScheduleLink(props: Readonly<FeeScheduleLinkProps>) {
  const { proposal } = props;

  const { openDialog } = useDialog();

  function handleClick(event: MouseEvent) {
    if (Masked.isMasked(proposal.feeSchedule)) {
      throw new Error("Cannot view masked fee schedule");
    }
    event.stopPropagation();
    const viewFeeScheduleComponent = (
      <FeeScheduleTemplatesTable
        hideActionsColumn={true}
        hideCommentButton={true}
        categories={proposal.feeSchedule}
        disableEditing={true}
        disableCategorySelection={true}
        commentsToolTip={""}
      />
    );

    openDialog({
      component: viewFeeScheduleComponent,
      title: "Fee Schedule",
      MuiProps: {
        maxWidth: "lg",
      },
    });
  }

  if (!proposal.feeSchedule) return null;
  if (Masked.isMasked(proposal.feeSchedule)) {
    return <span>(masked)</span>;
  }
  return (
    <FeeLink
      revised={
        !isNullOrUndefined(proposal?.supersedes) &&
          !_.isEqual(proposal?.feeSchedule, proposal?.supersedes?.workAgreement.feeSchedule)
      }
      onClick={handleClick}
    >
      View
    </FeeLink>
  );
}
